// rem 单位换算 1rem = 10px
export function htmlAuto() {
  // let zoom = detectZoom();

  const vw = document.body.clientWidth;
  const rootW = 10;

  let rem = (vw / 1920) * rootW;
  // if (vw <= 3400) rem = (vw / 3400) * rootW;
  // if (vw <= 2400) rem = (vw / 2400) * rootW;
  // if (vw <= 1920) rem = (vw / 1920) * rootW;
  // if (vw <= 1680) rem = (vw / 1680) * rootW;
  // if (vw <= 1440) rem = (vw / 1440) * rootW;
  // if (vw <= 1280) rem = (vw / 1280) * rootW;
  if (vw <= 980) rem = (vw / 980) * rootW;
  if (vw <= 750) rem = (vw / 750) * rootW;
  // if (vw <= 640) rem = (vw / 640) * rootW;
  // if (vw <= 375) rem = (vw / 375) * rootW;

  // if (vw <= 1920) zoom = 1;
  // console.log(rem, zoom, vw, "+++++rem");
  // document.documentElement.style.fontSize = rem * zoom + "px";
  // console.log(rem, vw, "+++++rem");
  document.documentElement.style.fontSize = rem + "px";
}

// 获取屏幕缩放比例
// function detectZoom() {
//   var ratio = 0,
//     screen = window.screen,
//     ua = navigator.userAgent.toLowerCase();

//   if (window.devicePixelRatio !== undefined) {
//     ratio = window.devicePixelRatio;
//   } else if (~ua.indexOf("msie")) {
//     if (screen.deviceXDPI && screen.logicalXDPI) {
//       ratio = screen.deviceXDPI / screen.logicalXDPI;
//     }
//   } else if (
//     window.outerWidth !== undefined &&
//     window.innerWidth !== undefined
//   ) {
//     ratio = window.outerWidth / window.innerWidth;
//   }

//   if (ratio) return Math.round(ratio * 100) / 100;
// }
